export const mockDataDuplicateStatus = {
  success: true,
};
